import { Helmet } from "react-helmet";

import Banner from "components/Newsroom/Banner";
import NewsroomAdvice from "components/Newsroom/NewsroomAdvice";

const Newsroom = () => {
    return (
        <article>
            <Helmet>
                <title> CNP Seguros Holding Brasil | Entre em contato com a nossa Assessoria de Imprensa</title>
                <meta name="description" content="Envio de pautas, respostas ao consumidor, solicitações de entrevistas, fotos e outras informações referentes à CNP Seguros Holding Brasil, entre em contato com a nossa assessoria de imprensa." />
                <meta name="keywords" content="CNP Seguros, CNP Holding Brasil, imprensa, assessoria, pautas, fotos" />
            </Helmet>
            <Banner />
            <NewsroomAdvice />
        </article>
    );
};

export default Newsroom;